import React, { useState, useEffect, useContext } from 'react';

import { AppContext, HomepageContext } from '../context';
import { featuredItems, reviews } from '../data/homepage';
import Layout from '../Layout';
import { HeroBanner, Categories, TopServices, BookProcess, CustomersReview, ServiceType, UnifiedList } from '../home';

const Homepage = () => {
  const { userAgent } = useContext(AppContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let timer = setTimeout(() => setIsLoaded(true), 3000);
    return () => { clearTimeout(timer) }
  }, []);

  return (
    <HomepageContext.Provider value={{
        featured: featuredItems,
        reviews: reviews
      }}
    >
      <Layout isLoaded={isLoaded}>
        <div className="Homepage">
          { !userAgent.isMobile && <HeroBanner /> }
          { !userAgent.isMobile && <Categories /> }
          <TopServices />
          <BookProcess />
          <CustomersReview />
          { !userAgent.isMobile && <ServiceType /> }
          { !userAgent.isMobile && <UnifiedList /> }
        </div>
      </Layout>
    </HomepageContext.Provider>
  );
}

export default Homepage;